export const SelectionState = {
  UNSELECTED: 0,
  SOME_CHILDREN: 1,
  SELF_ONLY: 2,
  SELF_AND_CHILDREN: 3
};
